import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const duplicateAccountTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/account_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

interface DuplicateAccountTemplateInput {
  uuid: string;
  name: string;
}

export function useDuplicateAccountTemplate(onSuccessCallback: (newUuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateAccountTemplateInput) => duplicateAccountTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allAccountTemplates] });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the account template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
